const ScrollToNextElement = {
    init() {
        document.addEventListener('click', e => {
            if (!e.target.closest('.js-click-down')) {
                return false;
            }

            ScrollToNextElement.scrollToElement();
        });
    },

    scrollToElement() {
        const currentScrollPos = parseInt(window.scrollY);
        const element = document.querySelector('.js-home-video-header').nextElementSibling;
        const elementTopPos = parseInt(element.getBoundingClientRect().top);

        const yOffset = 0;

        // Position to scroll on the page
        const y = elementTopPos + currentScrollPos - yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }
};

ScrollToNextElement.init();